
export default (state = INITIAL.characterId, action) => {
    return state
}